import { Config } from "../../Config";
import { Word } from "../../stores/word/Word";
import { IImageService } from "./IImageService";
import { ImageListUtils } from "./ImageListUtils";

const DEV_IMAGE_LIST = "images_list_dev.txt";
const PRODUCTION_IMAGE_LIST = "images_list_production.txt";

const TO_WORD_IMAGES_DIR_URL = "static/word_images/";

export class ImageService implements IImageService {
  static LOADING_IMAGE_URL = "static/site_images/loading_spinner.gif";
  static BLANK_IMAGE_URL = "static/site_images/blank.png";

  private hasImageListLoaded = false;
  private wordsToResolve: Word[] = [];

  constructor() {
    let imageListFilename = PRODUCTION_IMAGE_LIST;
    if (Config.isLocalDev()) {
      imageListFilename = DEV_IMAGE_LIST;
    }

    const imageListUrl = "static/not-cached/" + imageListFilename;
    this.retrieveImageList(imageListUrl);
  }

  private retrieveImageList(imageListUrl: string) {
    const onError = (reason: string) => {
      console.error("Error retrieving image list:", reason);
    };

    fetch(imageListUrl).then(
      response => {
        response
          .text()
          .then(
            text => this.processImageList(text),
            rejected => onError(rejected)
          );
      },
      rejected => onError(rejected)
    );
  }

  private processImageList(text: string) {
    text.split("\n").forEach(line => {
      const word = this.getWordFromLine(line);
      if (!word) {
        return;
      }
      if (line.indexOf("150x150") >= 0) {
        ImageListUtils.addSmallFilenameForWord(word, line);
      } else {
        ImageListUtils.addLargeFilenameForWord(word, line);
      }
    });

    this.resolveCachedWords();
    this.hasImageListLoaded = true;
  }

  private getWordFromLine(line: string): string | null {
    let words = line.split("_");
    if (words.length === 0) {
      console.error("bad line - cannot extract word", line);
      return null;
    }
    let word = words[0];
    while (word.indexOf("-") >= 0) {
      word = word.replace("-", " ");
    }
    return word;
  }

  private resolveCachedWords() {
    this.wordsToResolve.forEach(word => this.resolveWordImageRequest(word));
    this.wordsToResolve.length = 0;
  }

  getSmallImageUrlForWord(word: Word) {
    if (!this.hasImageListLoaded) {
      this.wordsToResolve.push(word);
    } else {
      this.resolveWordImageRequest(word);
    }
  }

  private resolveWordImageRequest(word: Word) {
    // First get images specific to the original language.
    // This is required for words like 'tattoo' that have 2 different origin words(!)
    let localImageUrls = ImageListUtils.getSmallImageFilenamesForWord(
      word.word + `(${word.originalLanguage})`
    );

    if (!localImageUrls) {
      localImageUrls = ImageListUtils.getSmallImageFilenamesForWord(word.word);
    }

    let url = word.activeImageUrl;
    if (localImageUrls) {
      url = TO_WORD_IMAGES_DIR_URL + this.pickRandomUrl(localImageUrls);
      word.hasLocalImage = true;
    } else {
      // fallback to the public cloud (v. slow! and not accurate, but better than nothing):
      // DISABLED: results can be embarassing, and now we have images for most words
      // url = word.imageUrl;
      url = ImageService.BLANK_IMAGE_URL;
    }

    word.activeImageUrl = url;
  }

  private pickRandomUrl(urls: string[]): string {
    return urls[Math.floor(Math.random() * urls.length)];
  }
}



// WEBPACK FOOTER //
// ./services/image/ImageService.ts